<article
  class="flex gap-4 border-b border-gray-100 py-4 last:border-b-0"
  [attr.aria-label]="
    notification().title + (notification().reference ? ', ref ' + notification().reference : '')
  ">
  <div
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600"
    aria-hidden="true"
  >
    <svg
      class="h-5 w-5"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
      />
    </svg>
  </div>

  <div class="min-w-0 flex-1">
    @if (notification().reference) {
      <p class="text-xs font-medium text-blue-500">
        {{ notification().reference }}
      </p>
    }
    <h3 class="text-sm font-semibold text-[#1a2b6d]">
      {{ notification().title }}
    </h3>
    <p class="text-xs">{{ notification().message }}</p>
    <p class="mt-1 text-xs text-gray-400">
      {{ notification().createdAt | date: "d, MMMM y · h:mm a" }}
    </p>

    @if (notification().requiresAction) {
      <div class="mt-3 flex gap-3">
        <button
          type="button"
          class="min-h-10 flex-1 rounded-md border border-[#1a2b6d] px-3 text-sm font-medium text-[#1a2b6d] transition hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a2b6d]"
          (click)="decline()"
          [attr.aria-label]="'Decline notification ' + notification().id"
        >
          Decline
        </button>
        <button
          type="button"
          class="min-h-10 flex-1 rounded-md bg-[#1a2b6d] px-3 text-sm font-medium text-white transition hover:opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a2b6d]"
          (click)="accept()"
          [attr.aria-label]="'Accept notification ' + notification().id"
        >
          Accept
        </button>
      </div>
    }
  </div>
</article>
